import React from 'react';
import i18n from '../../i18n';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import CardActions from "@material-ui/core/CardActions/CardActions";
import {withStyles} from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip/Chip";
import {FormattedDate} from "react-intl";
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from "@material-ui/core/Divider/Divider";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";
import DeleteButton from "../Form/DeleteButton";
import Date from "../Formater/Date";

class CourseGrid extends React.Component {
    render() {
        const {courses, classes} = this.props;

        return (
            <section>
                <Grid container spacing={16}>
                    {courses.map(course => {

                        return (
                            <Grid item xs={12} sm={12} md={6} lg={4} key={course.id}>
                                <Card>
                                    <CardContent className={classes.cardContent}>
                                        <Grid container spacing={8} justify="space-between" alignItems="center">
                                            <Grid item xs={12}>
                                                    <Typography variant="h6" component="h2">
                                                        <EllipisWithTooltip>{course.name_short}</EllipisWithTooltip>
                                                    </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={8} justify="space-between" alignItems="center">
                                            <Grid item xs={6}>
                                                <Typography>
                                                    {i18n.get('courses.name')}{':'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography component='div'>
                                                    <EllipisWithTooltip>
                                                        {course.name}
                                                    </EllipisWithTooltip>
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={8} justify="space-between" alignItems="center">
                                            <Grid item xs={6}>
                                                <Typography>
                                                    {i18n.get('courses.seminar')}{':'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography>
                                                    {course.seminar}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={8} justify="space-between" alignItems="center">
                                            <Grid item xs={6}>
                                                <Typography>
                                                    {i18n.get('courses.start')}{':'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography>
                                                    <Date value={course.start}/>
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={8} justify="space-between" alignItems="center">
                                            <Grid item xs={6}>
                                                <Typography>
                                                    {i18n.get('courses.end')}{':'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography>
                                                    <Date value={course.end}/>
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        {/*<Grid container spacing={8} justify="space-between" alignItems="center">*/}
                                            {/*<Grid item xs={6}>*/}
                                                {/*<Typography>*/}
                                                    {/*{i18n.get('courses.duration')}{':'}*/}
                                                {/*</Typography>*/}
                                            {/*</Grid>*/}
                                            {/*<Grid item xs={6}>*/}
                                                {/*<Typography>*/}
                                                    {/*{course.duration}*/}
                                                {/*</Typography>*/}
                                            {/*</Grid>*/}
                                        {/*</Grid>*/}

                                        <Grid container spacing={8} justify="space-between" alignItems="center">
                                            <Grid item xs={6}>
                                                <Typography>
                                                    {i18n.get('courses.qualification')}{':'}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                {course.course_qualifications_with_qualification[0] &&
                                                <Typography>
                                                    {course.course_qualifications_with_qualification[0].qualification.name}
                                                </Typography>
                                                }
                                            </Grid>
                                        </Grid>

                                        {/*<Grid container spacing={8} justify="space-between" alignItems="center">*/}
                                            {/*<Grid item xs={6}>*/}
                                                {/*<Typography>*/}
                                                    {/*{i18n.get('courses.lecturer')}{':'}*/}
                                                {/*</Typography>*/}
                                            {/*</Grid>*/}
                                            {/*<Grid item xs={6}>*/}
                                                {/*<Typography>*/}
                                                    {/*{course.lecturer}*/}
                                                {/*</Typography>*/}
                                            {/*</Grid>*/}
                                        {/*</Grid>*/}
                                    </CardContent>

                                    <Divider />

                                    <CardActions className={classes.cardActions}>
                                        <Grid container justify="space-between" alignItems="center">
                                            <Grid item>
                                                <Typography>
                                                    {i18n.get('courses.participants')}: {course.participations.length}
                                                </Typography>

                                                {/*{course.telephone && (*/}
                                                    {/*<Tooltip placement="bottom-start" title={course.telephone} classes={{tooltip : classes.popper}}>*/}
                                                        {/*<IconButton href={`tel:${course.telephone}`} className={classes.iconButton}>*/}
                                                            {/*<Icon className={classes.iconButtonIcon}>phone</Icon>*/}
                                                        {/*</IconButton>*/}
                                                    {/*</Tooltip>*/}
                                                {/*)}*/}
                                            </Grid>

                                            <Grid item>
                                                <Tooltip placement="bottom-end" title={i18n.get('courses.edit')} classes={{tooltip : classes.popper}}>
                                                    <IconButton href={`/courses/${course.id}-${course.name_short}/edit`} className={classes.iconButton}>
                                                        <Icon className={classes.iconButtonIcon}>edit</Icon>
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip placement="bottom-end" title={i18n.get('courses.schedule')} classes={{tooltip : classes.popper}}>
                                                    <IconButton href={`/schedules/${course.id}-${course.name_short}`} className={classes.iconButton}>
                                                        <Icon className={classes.iconButtonIcon}>schedule</Icon>
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip placement="bottom-end" title={i18n.get('courses.participants')} classes={{tooltip : classes.popper}}>
                                                    <IconButton href={`/participations/${course.id}-${encodeURIComponent(course.name_short)}`} className={classes.iconButton}>
                                                        <Icon className={classes.iconButtonIcon}>person</Icon>
                                                    </IconButton>
                                                </Tooltip>

                                                <Tooltip placement="bottom-end" title={i18n.get('courses.participants_add')} classes={{tooltip : classes.popper}}>
                                                    <IconButton href={`/participations/${course.id}-${course.name_short}/create`} className={classes.iconButton}>
                                                        <Icon className={classes.iconButtonIcon}>person_add</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </CardActions>
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>
            </section>
        )
    }
}

const styles = theme => ({
    cardContent: {
        minHeight: '200px'
    },
    cardActions: {
        padding: '4px 8px',
    },
    chip: {
        height: '24px',
    },
    chipLabel: {
        padding: '0 8px'
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1
        }
    },
    iconButtonIcon: {
        fontSize: 20
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)'
    }
});

export default withStyles(styles)(CourseGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Courses/CourseGrid.js